import {Config} from '../../shared/config';
// import {Config} from '@ema/js-base/dist/collection/lib/config/config';
import {Injectable} from '@angular/core';

@Injectable()
export class ConfigService extends Config {

    // _config;
    // add;
    // fetch;
    // all;
    // get;
    // set;
    // setLocalSettings;
    // extend;
    // lock;
    // setDefaults;

    constructor() {
        super();
    }

    public services: any = {
        appService: undefined,
        translateService: undefined,
    };

    initialize(options) {
        const self = this;
        return new Promise(function (resolve, reject) {
            if(options.config) {
                self.add(options.config);
            }
            if(options.settingsFile) {
                self.fetch(options.settingsFile, true).then(() => {
                    self.setLocalSettings(self.get('id'), self.all());
                    self.set('ready', true);
                    resolve(self.all());
                    // todo: xdomain
                    // if(self.settings.xdomain){
                    //   self.initXdomain(res.xdomain)
                    // }
                });
            } else {
                self.setLocalSettings(self.get('id'), self.all());
                self.set('ready', true);
                resolve(self.all());
            }
        });

    }

}
